import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.15.0_db0@0.2.1_drizzle-orm@0.33.0_rollup@4.29.1_typescript@5.7.2_vite@6.0.6/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.15.0_db0@0.2.1_drizzle-orm@0.33.0_rollup@4.29.1_typescript@5.7.2_vite@6.0.6/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}